import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, sub, center = true, testId }) => (
  <div className={`mb-16 ${center ? "text-center" : "text-left"}`}>
    {eyebrow && (
      <Reveal>
        <p className="text-fuchsia tracking-[0.35em] uppercase text-xs font-semibold mb-5" data-testid={testId ? `${testId}-eyebrow` : undefined}>
          {eyebrow}
        </p>
      </Reveal>
    )}
    <Reveal delay={0.1}>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]" data-testid={testId ? `${testId}-title` : undefined}>
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.2}>
        <p className="mt-6 text-muted text-base md:text-lg max-w-2xl leading-relaxed" style={center ? { marginInline: "auto" } : {}}>
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);
